import type { UseQueryOptions } from '@pinia/colada';

import { Duration, MILLISECONDS } from '@/lib/date-time/duration';

export const STATIC_QUERY_OPTIONS = {
  // "initialDataUpdatedAt: 0" with "refetchOnMount: true" means that data will be refetched on mount
  initialDataUpdatedAt: 0,
  refetchOnMount: true,
  refetchOnWindowFocus: false,
  staleTime: Duration.DAY * MILLISECONDS,
} as const satisfies Partial<UseQueryOptions>;

export const STABLE_QUERY_OPTIONS = {
  gcTime: 30 * Duration.MINUTE * MILLISECONDS,
  staleTime: 10 * Duration.MINUTE * MILLISECONDS,
} as const satisfies Partial<UseQueryOptions>;

export const DYNAMIC_QUERY_OPTIONS = {
  staleTime: 0,
} as const satisfies Partial<UseQueryOptions>;
